import styles from "../../style.module.scss";
import DatePicker, {registerLocale} from "react-datepicker";
import {useEffect, useRef, useState} from "react";
import "../../datepicker.css";
import ru from "date-fns/locale/ru";
import {subDays} from "date-fns";
import useStore from "../../store/store";
import {hoursSelect} from "../../const/const";
import formatDate from "../../utils/format-date";
import formatHours from "../../utils/format-hours";
import CheckAvailable from "../check-available/check-available";

registerLocale("ru", ru);

function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

function Step1({number, minRentDays}) {
    const datePickerRef = useRef();
    const [isMobile, setIsMobile] = useState(false);
    const currentDate = useStore((state) => state.currentDate)
    const startDate = useStore((state) => state.startDate)
    const setStartDate = useStore((state) => state.setStartDate)
    const startHours = useStore((state) => state.startHours)
    const setStartHours = useStore((state) => state.setStartHours)
    const finishDate = useStore((state) => state.finishDate)
    const setFinishDate = useStore((state) => state.setFinishDate)
    const finishHours = useStore((state) => state.finishHours)
    const setFinishHours = useStore((state) => state.setFinishHours)

    const sliceHoursCount = !!startDate?.getDate() && !!currentDate?.getDate() && startDate.getDate() === currentDate.getDate() ? parseInt(currentDate.getHours()) : 0;


    const onChangeDatepicker = (dates) => {
        const [start, finish] = dates;
        setStartDate(start);
        setFinishDate(finish);
    };

    const onChangeHoursSelect = (e) => {
        if (e.target.name === 'startHours') {
            setStartHours(parseInt(e.target.value));
        }
        if (e.target.name === 'finishHours') {
            setFinishHours(parseInt(e.target.value));
        }
    }
    const handleCLoseClick = () => {
        if (!startHours) {
            setStartHours(sliceHoursCount)
        }
        if (!finishHours) {
            setFinishHours(0)
        }

        datePickerRef.current.setOpen(false);
    }
    useEffect(() => {
        let now = new Date().addHours(3);
        let def = false;
        if (startDate === null || startHours === null) {
            let b_date_start = !!localStorage.getItem('b_date_start') ? localStorage.getItem('b_date_start').split('-') : null;
            let b_time_start = !!localStorage.getItem('b_time_start') ? localStorage.getItem('b_time_start').split(':') : null;
            console.log('start', b_date_start, b_time_start)
            if (!!b_date_start && !!b_time_start) {
                const newStartDate = new Date(b_date_start[2], b_date_start[1] - 1, b_date_start[0], b_time_start[0], b_time_start[1], 0);
                const newStartHours = b_time_start[0];
                console.log('newStartDate', newStartDate, 'newStartHours', newStartHours)
                if (newStartDate > now) {
                    console.log('case1')
                    setStartDate(newStartDate);
                    setStartHours(parseInt(newStartHours));
                } else {
                    setStartDate(now);
                    console.log('case2')
                    setStartHours(parseInt(now.getHours()));
                    def = true;
                }
            } else {
                console.log('case3')
                setStartDate(now);
                setStartHours(parseInt(now.getHours()));
                def = true;
            }
        }
        if (finishDate === null || finishHours === null) {
            let b_date_finish = !!localStorage.getItem('b_date_finish') ? localStorage.getItem('b_date_finish').split('-') : null;
            let b_time_finish = !!localStorage.getItem('b_time_finish') ? localStorage.getItem('b_time_finish').split(':') : null;
            console.log('finish', b_date_finish, b_time_finish)
            if (!!b_date_finish && !!b_time_finish) {
                const newFinishDate = new Date(b_date_finish[2], b_date_finish[1] - 1, b_date_finish[0], b_time_finish[0], b_time_finish[1], 0);
                const newFinishHours = b_time_finish[0];
                if (newFinishDate > now && !def) {
                    console.log('case4')
                    setFinishDate(newFinishDate);
                    setFinishHours(parseInt(newFinishHours));
                } else {
                    console.log('case5')
                    setFinishDate(addDays(now, minRentDays));
                    setFinishHours(parseInt(addDays(now, minRentDays).getHours()));
                }
            } else {
                console.log('case6')
                setFinishDate(addDays(now, minRentDays));
                setFinishHours(parseInt(addDays(now, minRentDays).getHours()));
            }
        }
    }, []);
    useEffect(() => {
        if (window.innerWidth <= 991) {
            setIsMobile(true);
        }
    }, []);
    useEffect(() => {
        if (!!startDate?.getDate() && sliceHoursCount > 0 && sliceHoursCount > startHours) {
            setStartHours(sliceHoursCount)
        }
    }, [startDate, sliceHoursCount, startHours, setStartHours]);
    return (<div className={styles.newOrder__step}>
        <div className={`${styles.newOrder__stepHead} p-size`}>
            <div className={styles.newOrder__stepNumber}>
                {number}
            </div>
            Укажите период
        </div>
        <div className={styles.newOrder__stepContent}>

            <input type="text" id={'userDateStart'} className={styles.dateInput} placeholder={`Дата начала`}
                   value={formatDate(startDate)}
                   disabled/>
            <input type="text" className={styles.timeInput} placeholder={`Время начала`}
                   value={formatHours(startHours)}
                   disabled/>
            <input type="text" className={styles.dateInput} placeholder={`Дата возврата`}
                   value={formatDate(finishDate)}
                   disabled/>
            <input type="text" className={styles.timeInput} placeholder={`Время возврата`}
                   value={formatHours(finishHours)}
                   disabled/>
            <DatePicker
                ref={datePickerRef}
                className={styles.calendar}
                closeOnScroll={!isMobile}
                onChange={onChangeDatepicker}
                monthsShown={2}
                startDate={startDate}
                endDate={finishDate}
                locale="ru"
                selectsRange
                minDate={subDays(currentDate, 0)}
                withPortal
                shouldCloseOnSelect={false}
                onCalendarOpen={() => {
                    document.activeElement.blur();
                }}
            >
                <div className={styles.datePickerFooter}>
                    <div className={styles.col}>
                        Время начала
                        <select name={`startHours`} onChange={onChangeHoursSelect}
                                value={startHours !== null ? startHours : ''}>
                            {hoursSelect.slice(sliceHoursCount).map((item, index) => <option key={index}
                                                                                             value={index}>{item}</option>)}
                        </select>
                    </div>
                    <div className={styles.col}>
                        Время возврата
                        <select name={`finishHours`} onChange={onChangeHoursSelect}
                                value={finishHours !== null ? finishHours : ''}>
                            {hoursSelect.map((item, index) => <option key={index} value={index}>{item}</option>)}
                        </select>
                    </div>
                    <button className={styles.button} onClick={() => handleCLoseClick()}>Применить</button>
                </div>

            </DatePicker>

        </div>
        <CheckAvailable/>
    </div>)
}

export default Step1;